import { Effect, Layer } from "effect";
import { EditorPlatform, editorPlatformFailure } from "./platform-service.ts";
export const EditorPlatformLive = Layer.effect(EditorPlatform, Effect.gen(function* () {
  const ready = yield* Effect.cached(Effect.gen(function* () { const platform = yield* Effect.tryPromise({ try: () => import("./platform-monaco-live.ts"), catch: editorPlatformFailure }); yield* platform.prepareEditorPlatform; }));
  return EditorPlatform.of({ ready });
}));
